import styled from 'styled-components';

type SizeType = 'small' | 'medium' | 'large';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	margin-top: 50px;
	margin-bottom: 100px;
	padding: 24px;
`;

export const IconWrapper = styled.div`
	margin-bottom: 16px;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
`;

export const Title = styled.div`
	font-size: 24px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	margin-bottom: 12px;
	line-height: 1.3;
`;

export const Description = styled.div`
	font-size: 16px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	line-height: 1.5;

	a {
		color: ${({ theme }) => theme.colors.text.link};
	}
`;

export const ActionWrapper = styled.div`
	margin-top: 24px;
`;